<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>OEB Producción</f7-nav-title>
    </f7-navbar>
    <div class="sello-datos-bar"><sello-datos estado="vivo" /></div>
    <f7-block-header style="font-size: 13px; color: #666; margin-top: 8px">
      Herramientas de control de producción
    </f7-block-header>
    <div class="oeb-grid">
      <f7-link href="/dashboard/oeb/control-cifras/" class="oeb-card active" style="border-bottom: 4px solid #534AB7" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
        <div class="card-icon" style="background: #EEEDFE">
          <f7-icon f7="graph_square" style="color: #534AB7; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Control de cifras</p>
        <p class="card-subtitle">Ficha mensual</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/resumen-anual/" class="oeb-card active" style="border-bottom: 4px solid #185FA5" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
        <div class="card-icon" style="background: #E6F1FB">
          <f7-icon f7="calendar" style="color: #185FA5; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Resumen anual</p>
        <p class="card-subtitle">Visión 12 meses</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/configuracion/" class="oeb-card active" style="border-bottom: 4px solid #0F6E56" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
        <div class="card-icon" style="background: #E1F5EE">
          <f7-icon f7="gear_alt" style="color: #0F6E56; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Configuración</p>
        <p class="card-subtitle">Personas y objetivos</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/ejercicios/" class="oeb-card active" style="border-bottom: 4px solid #BA7517" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
        <div class="card-icon" style="background: #FAEEDA">
          <f7-icon f7="chart_bar_alt_fill" style="color: #BA7517; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Por ejercicios</p>
        <p class="card-subtitle">Histórico 2007-{{ new Date().getFullYear() }}</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/notificaciones/" class="oeb-card active" style="border-bottom: 4px solid #D85A30" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
        <div class="card-icon" style="background: #FAECE7">
          <f7-icon f7="bell_fill" style="color: #D85A30; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Notificaciones</p>
        <p class="card-subtitle">Reglas y envíos</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/planificacion/" class="oeb-card active" style="border-bottom: 4px solid #2d5f8a" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
        <div class="card-icon" style="background: #E6EEF6">
          <f7-icon f7="calendar_badge_clock" style="color: #2d5f8a; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Planificación</p>
        <p class="card-subtitle">Ficha mensual planificación</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/analisis/" class="oeb-card active" style="border-bottom: 4px solid #7B2D8E; position:relative" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
        <span style="position:absolute;top:6px;right:6px;background:#FEF3C7;color:#B45309;border-radius:10px;padding:3px 10px;font-size:10px;font-weight:600;letter-spacing:0.3px">EN DESARROLLO</span>
        <div class="card-icon" style="background: #F3E8F9">
          <f7-icon f7="doc_text_search" style="color: #7B2D8E; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Análisis diferencias</p>
        <p class="card-subtitle">OEB vs TPC(SI)</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/productividad/" class="oeb-card active" style="border-bottom: 4px solid #0B5345" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
        <div class="card-icon" style="background: #D5F5E3">
          <f7-icon f7="person_2_fill" style="color: #0B5345; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Productividad</p>
        <p class="card-subtitle">Datos anuales por persona</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/prod-plan/" class="oeb-card active" style="border-bottom: 4px solid #2d5f8a" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
        <div class="card-icon" style="background: #E6EEF6">
          <f7-icon f7="chart_bar_square" style="color: #2d5f8a; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Prod. Planificaci&oacute;n</p>
        <p class="card-subtitle">Productividad planificadores</p>
      </f7-link>
      <f7-link href="/dashboard/oeb/planificacion-diaria/" class="oeb-card active" style="border-bottom: 4px solid #E91E63" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
        <div class="card-icon" style="background: #FCE4EC">
          <f7-icon f7="clock" style="color: #E91E63; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Plan. Diaria</p>
        <p class="card-subtitle">Timeline diaria por hora</p>
      </f7-link>
      <!-- Segundo acceso al panel (además del botón del calendario). Gate ADMIN/PLANIFICADOR, igual que
           su ruta y el botón. NO se gatea por el flag: el flag solo controla que haya datos (con el flag
           OFF el panel sale vacío), igual que el botón del calendario. -->
      <f7-link href="/dashboard/informes-pendientes/" class="oeb-card active" style="border-bottom: 4px solid #4a3aa7" v-roles="['ADMIN','PLANIFICADOR']">
        <div class="card-icon" style="background: #EFEDFB">
          <f7-icon f7="doc_chart_fill" style="color: #4a3aa7; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Informes pendientes</p>
        <p class="card-subtitle">TPI(No) por inspector</p>
      </f7-link>
      <!-- Agente IA F1 · panel de doble control (Dirección Técnica). Mismo mecanismo que Informes (tarjeta
           en código). Se muestra SOLO donde el flag del agente está ON (dev en revisión de la DT); en prod
           (flag OFF) no aparece hasta pasar el gate de F3. Rol: ADMIN/DIRECTOR/DTYCAL. -->
      <f7-link v-if="agenteHabilitado" href="/dashboard/agente-aprendizaje/" class="oeb-card active" style="border-bottom: 4px solid #23407e" v-roles="['ADMIN','DIRECTOR','DTYCAL']">
        <div class="card-icon" style="background: #E6EEF6">
          <f7-icon f7="gauge" style="color: #23407e; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">Agente IA · Tiempos</p>
        <p class="card-subtitle">Aprobar ajustes (doble control)</p>
      </f7-link>
      <!-- #326 · la entrada a Control de Planificación, que hasta ahora no tenía ninguna: la
           pantalla existía y solo se llegaba escribiendo la dirección. Va al final de la rejilla
           para no mover de sitio ninguna de las que ya estaban.

           NO se gatea con `v-roles` como las de arriba, sino con el menú efectivo del usuario:
           `v-roles` deja pasar siempre a ADMIN, pero `RoutesUtils.checkPermission` responde 403 si
           la ruta no cuelga del menú de Mongo AUNQUE sea ADMIN, así que la tarjeta se vería y no
           llevaría a ninguna parte. La regla de Dirección (`CLAUDE.md` §9, #69) dice justo eso: si
           la pantalla no es alcanzable, su punto de entrada no se dibuja. La entrada de menú la da
           de alta el lote `fase-menu-control-planificacion-2026-10` de `simecal-api-movilidad`. -->
      <f7-link v-if="puedeControlPlanificacion" :href="rutaControlPlanificacion" class="oeb-card active" style="border-bottom: 4px solid #1F6F8B">
        <div class="card-icon" style="background: #E4F0F4">
          <f7-icon f7="calendar_badge_minus" style="color: #1F6F8B; font-size: 24px"></f7-icon>
        </div>
        <!-- #1133 · el nombre, de la misma clave que el menú lateral: «ACEL PLANIFICACIÓN». -->
        <p class="card-title">{{ $t('main_menu.controlplanificacion') }}</p>
        <p class="card-subtitle">L&iacute;neas EST PLA y anomal&iacute;as</p>
      </f7-link>
    </div>
  </f7-page>
</template>
<style scoped>
.oeb-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(140px,1fr)); gap:16px; padding:16px; }
.oeb-card { background:white; border-radius:12px; border:1px solid #e0e0e0; padding:20px; text-align:center; transition:transform 0.2s; display:flex; flex-direction:column; align-items:center; }
.oeb-card.active { cursor:pointer; }
.oeb-card.active:active { transform:scale(0.97); }
.oeb-card.disabled { opacity:0.5; pointer-events:none; }
.card-icon { width:52px; height:52px; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 12px; }
.card-title { font-size:14px; font-weight:600; color:#1a2744; margin:0; }
.card-subtitle { font-size:11px; color:#7c8db0; margin:2px 0 0; }
.card-badge { font-size:10px; margin-top:8px; color:#999; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; }
</style>
<script>
import AgenteAprendizaje from '../../js/db/AgenteAprendizaje.js';
import SelloDatos from '../../components/SelloDatos.vue';
import { puedeAbrirControlPlanificacion, RUTA_CONTROL_PLANIFICACION } from './permisos-control-planificacion.js';
export default {
  components: { SelloDatos },
  // Se resuelve en `data()` y no en `mounted()` a propósito: el menú ya está en el usuario de la
  // sesión y `tieneAcceso` contesta al instante, así que la tarjeta no aparece de golpe medio
  // segundo después de pintarse la rejilla.
  data() {
    return {
      agenteHabilitado: false,
      puedeControlPlanificacion: puedeAbrirControlPlanificacion(),
      rutaControlPlanificacion: RUTA_CONTROL_PLANIFICACION
    };
  },
  mounted() {
    var self = this;
    // La tarjeta del Agente solo aparece donde el flag del motor está ON (dev en revisión; no prod).
    AgenteAprendizaje.estado().then(function(res) { self.agenteHabilitado = !!(res && res.habilitado); }).catch(function() {});
  }
};
</script>
